

export interface SegmentedOption<T extends string = string> {
  value: T;
  label: string;
}

interface SegmentedProps<T extends string = string> {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (v: T) => void;
}

export function Segmented<T extends string = string>({
  options,
  value,
  onChange,
}: SegmentedProps<T>) {
  return (
    <div className="ds-segmented">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className={value === o.value ? "active" : ""}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
